import * as React from 'react';

// ICONS
import { ReactComponent as ArrowUpIcon } from '../assets/svg/arrow-up.svg';

export interface ScrollToTopButtonTypes {
	extraClass?: string;
	offsetValue?: number;
}

const ScrollToTopButton: React.FC<ScrollToTopButtonTypes> = ({ extraClass, offsetValue }) => {
	const [visible, setVisible] = React.useState<boolean>(false);

	const scrollToTop = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
		e.preventDefault();

		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		});
	};

	React.useEffect(() => {
		const scrollControl = () => {
			if (!visible && window.pageYOffset > 100) {
				setVisible(true);
			} else if (visible && window.pageYOffset <= 100) {
				setVisible(false);
			}
		};
		
		window.addEventListener('scroll', scrollControl);

		return () => {
			window.removeEventListener('scroll', scrollControl);
		};
	}, []);

	return (
		<div className="back-to-top-btn-container">
			<button
				className={`btn-back-to-top ${extraClass ? extraClass : ''}`}
				onClick={scrollToTop}
				style={{ display: visible ? 'inline' : 'none', transform: `translateY(-${offsetValue}%)` }}
			>
				<ArrowUpIcon className="link-icon" />
				Back to top
			</button>
		</div>
	);
};

export default ScrollToTopButton;
